import { render, staticRenderFns } from "./GlobalInputNumber.vue?vue&type=template&id=61bdb672&scoped=true&"
import script from "./GlobalInputNumber.vue?vue&type=script&lang=js&"
export * from "./GlobalInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./GlobalInputNumber.vue?vue&type=style&index=0&id=61bdb672&lang=less&scoped=true&"
import style1 from "./GlobalInputNumber.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdb672",
  null
  
)

export default component.exports